
export class StringUtils{
    
    static transformMongoCondigion(filters: any[]) {
        let filter = {};
        for (const f of filters) {
            if (f.value == null || f.value === '') {
                continue;
            }   
            if (StringUtils.isDate(f.value) || StringUtils.isDateTime(f.value) || StringUtils.isDateTimeWithoutT(f.value)) { 
                filter[f.key] = { $gte: `ISODate('${StringUtils.formatDate(f.value)}')` };
            } else {
                if ( f.key == '_id'){
                    filter[f.key] = `ObjectId('${f.value.trim()}')`;
                } else {
                    filter[f.key] = f.value;
                }
            }
        }
        return filter;
    }

    public static stringifyMongoCondition(condition: any): string {
        return JSON.stringify(condition)
            .replace(/"ObjectId\('([a-fA-F0-9]{24})'\)"/g, "ObjectId('$1')")
            .replace(/"ISODate\('([^']+)'\)"/g, "ISODate('$1')");
    }
    
    static formatDate(value: any) {
        if (value instanceof Date) {
            return value.toISOString();
        } else if (typeof value === 'string') {
            const date = new Date(value);   
            if (!isNaN(date.getTime())) {
                return date.toISOString();
            }
        }
        return value; // Retorna o valor original se não for uma data válida
    }
    

    public static toCamelCase(str:string){
        return str
        .replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
    }

    public static toDisCamelCase(str:string){
        return str.substring(0,1).toUpperCase()+str.substring(1).toLowerCase();
        
    }

    public static safeSplit(value:string, delimiter:string, bracketLeft:string='[', bracketRight:string=']'):string[] {
		
        let open = 0; // contagem de parênteses abertos
        let posicoes:number[] = [];
        for (let i:number = 0; i < value.length; i++) {
            let c:string = value.charAt(i);
            
            if (c == bracketLeft ) {
                open++;
            } else if (c == bracketRight) {
                open--;
            } else if (c == delimiter.charAt(0) && open == 0) {
                posicoes.push(i);
            }
        }

        let partes:string[]  = [];
        let posInicial = 0;

        for ( const pos of posicoes) {
            // usar as posições em que estão os pontos para obter substrings
            partes.push(value.substring(posInicial, pos));
            posInicial = pos + 1;
        }
        
        partes.push(value.substring(posInicial));
        
        return partes;
    }

    public static stringToBoolean(str: string): boolean {
        const boolMap = new Map<string, boolean>([
            ['true', true],
            ['false', false],
            ['yes', true],
            ['no', false],
            ['1', true],
            ['0', false]
        ]);
    
        const result = boolMap.get(str.toLowerCase());
        if (result !== undefined) {
            return result;
        } else {
            throw new Error('Invalid boolean string');
        }
    }

    public static UIDGerador():string{
        let d = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
        return uuid;
    }

    static isDate(value: string): boolean {
        const datePattern:RegExp = new RegExp(/^\d{4}-\d{2}-\d{2}$/); // Exemplo de valor: 2026-04-01
        return datePattern.test(value);
    }

    static isDateTime(value: string): boolean {
        // Exemplo de valor: 2026-04-01 14:14:45 ou 2026-04-01T14:14:45Z
        const dateTimePattern:RegExp =new RegExp( /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/);
        return dateTimePattern.test(value);
    }

    static isDateTimeWithoutT(value: string): boolean {
        // Exemplo de valor: 2026-04-01 14:14:45
        const dateTimePattern:RegExp =new RegExp( /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/);
        return dateTimePattern.test(value);
    }
       

}